module.exports = __webpack_public_path__ + "img/chang-tien-wei-10.732de301.jpg";